import React from "react";
import { FaStar, FaMapMarkerAlt, FaVideo } from "react-icons/fa";
import { formatExperienceYears } from "../utils/consultation";
import { ViewDirections } from "../utils/bookingModels";

const DoctorCard = ({ doctor, onBookConsult, consultationType }) => {
  const filled = doctor.primaryAction?.style === "filled";
  const raw = doctor._raw || {};
  const fee = raw.consultation_fee;
  const isOnline = consultationType === "video" || raw.consultation_type === "Online";

  return (
    <div className="bg-surface-lowest rounded-xl border border-surface-container p-3 sm:p-4 flex flex-col shadow-sm hover:shadow-md transition-shadow min-w-0">
      <div className="flex items-start gap-3 min-w-0">
        <img
          src={doctor.profilePictureUrl}
          alt={doctor.name}
          className="w-14 h-14 sm:w-16 sm:h-16 rounded-full object-cover shrink-0"
          onError={(e) => { e.target.src = "/logo.png"; }}
        />
        <div className="min-w-0 flex-1">
          <h2 className="font-bold text-sm sm:text-base text-on-primary-fixed-var leading-tight truncate">{doctor.name}</h2>
          <p className="text-xs sm:text-sm text-primary mt-0.5 truncate">{doctor.specialty}</p>
          <p className="text-sm text-on-primary-fixed-var mt-1.5 flex items-center gap-1">
            <FaStar className="text-yellow-400 shrink-0" size={12} />
            <span>{doctor.ratingAverage}</span>
          </p>
        </div>
      </div>

      {(doctor.description || raw.qualification) && (
        <p className="text-sm text-on-surface-variant mt-3 line-clamp-2">
          {doctor.description || raw.qualification}
        </p>
      )}

      <div className="mt-3 sm:mt-4 space-y-2 text-xs sm:text-sm border-t border-surface-container pt-3 sm:pt-4">
        <div className="flex justify-between items-center">
          <span className="text-on-surface-variant">Experience</span>
          <span className="font-medium text-on-primary-fixed-var">{formatExperienceYears(doctor.experienceYears)}</span>
        </div>
        {fee != null && fee !== "" && (
          <div className="flex justify-between items-center">
            <span className="text-on-surface-variant">Consultation Fee</span>
            <span className="font-medium text-on-primary-fixed-var">₹{Number(fee).toLocaleString("en-IN")}</span>
          </div>
        )}
        <div className="flex justify-between items-center">
          <span className="text-on-surface-variant">Next Available</span>
          <span className={`font-medium ${filled ? "text-primary" : "text-on-primary-fixed-var"}`}>
            {doctor.nextAvailableDatetime}
          </span>
        </div>
        <div className="flex justify-between items-start gap-2">
          <span className="text-on-surface-variant shrink-0">{isOnline ? "Mode" : "Location"}</span>
          {isOnline ? (
            <span className="inline-flex items-center gap-1 text-xs font-medium text-primary bg-primary-fixed/30 px-2 py-1 rounded-full">
              <FaVideo size={10} /> Video consult
            </span>
          ) : (
            <span className="text-right text-xs text-on-primary-fixed-var flex items-start gap-1 justify-end">
              <FaMapMarkerAlt className="text-primary shrink-0 mt-0.5" size={10} />
              <span className="line-clamp-2">{raw.address || "Clinic visit"}</span>
            </span>
          )}
        </div>
        {!isOnline && <ViewDirections url={raw.locationUrl} className="text-xs font-semibold text-primary" />}
      </div>

      <button
        type="button"
        onClick={() => onBookConsult(doctor._raw)}
        className={`mt-3 sm:mt-4 w-full py-2.5 rounded-lg text-sm font-semibold transition ${
          filled
            ? "bg-primary text-white hover:bg-primary-container"
            : "border-2 border-primary text-primary bg-surface-lowest hover:bg-primary-fixed/30"
        }`}
      >
        Book Consult
      </button>
    </div>
  );
};

export default DoctorCard;
